import { render, staticRenderFns } from "./EmptyApp.vue?vue&type=template&id=3c31b2f2&scoped=true&"
import script from "./EmptyApp.vue?vue&type=script&lang=js&"
export * from "./EmptyApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c31b2f2",
  null
  
)

export default component.exports